import {React, useContext} from 'react'
import bg_img3 from './static/img/bg-img3.jpg'
import BreadcrumbsSection from './BreadcrumbsSection'
import OurServicesSection from './OurServicesSection'
import FeedbackSection from './FeedbackSection'
import RoutesContext from '../contexts/RoutesContext'

function Service3Page(props) {
    let routes_context = useContext(RoutesContext)

  return (
    <main onLoad={routes_context.flip_card_resize}>
        
        <BreadcrumbsSection routes={routes_context.routes} page_name='Services' />
        <div className="services_banner_section">
            <div className="services_banner_inner_wrapper">
                <img src={bg_img3} alt="" />
            </div>
        </div>

        <OurServicesSection routes={routes_context.routes} setCurrentPage = {routes_context.setCurrentPage} />

        <div className="content_section" id="content_section">
            <div className="content_inner_wrapper">
                <h1 className="service_content_title">DRAFT OF PERMISSIBLE DISCHARGE NORMS</h1>
                <p>
                    Islendik iri kärhana suwdan peýdalanýar, onuň öz işlerini amala aşyrmagynyň barşynda, akdyrylýan hapa suwlar emele gelmegine getirýär, şol suwlar ýerleriň relýefine ýa-da suw toplanýan meýdançalara dökýärler. Şoňa görä-de, dökmeleriň rugsat edilýän kada görkezijilerini takyk hasaplanmagyna we şol görkezijilerden çykylmazlygyna wajyp ähmiýet berilýär.
                </p>
               <p>
                Eger kärhana hapa suwlary suw obýektine akdyrýan bolsa, onda bu kärhana üçin akdyrmagyň Rugsat edilýän aňryçäk dökmeleriň (READ) taslamasyny işläp düzmek gerek. Dökmeleriň rugsat edilýän normatiwleriniň (DREN) we rugsat edilýän aňryçäk dökmelere kada görkezijileriniň (READKG) taslamalary biri-birinden düýpgöter tapawutlanýar, Dökmeleriň rugsat edilýän normatiwleriniň (DREN) taslamalary suw obýektlerine – derýalara, köllere, deňizlere boýunça amala aşyrylýar, rugsat edilýän aňryçäk dökmelere kada görkezijileriniň (READKG) taslamalary kärhananyň çäginden guramaçylyksyz akdyrylmagyna degişlidir.
               </p>
                <p>
                    Rugsat edilýän aňryçäk dökmelere kada görkezijileri (READKG) – munuň özi suwdaky hapalaýjy maddanyň kesgitlenen ýerde wagt birligine görä sowulmagyna (akdyrylmagyna) rugsat edilýän ýokary düzümini häsiýetlendirýän görkezijidir.
                </p>
                <p>
                    Dökmeleriň çeşmeleri bolan edaranyň öňünde durýan esasy wezipe suwuň hiliniň normatiwlerdäki görkezijilerden pese düşmegine ýa-da bozulmalar eýýäm ýüze çykan halatynda, şol bozulmalaryň artmagyna ýol bermezlikden ybaratdyr.
                </p>                
                <p>
                    Rugsat edilýän aňryçäk dökmelere kada görkezijileri (READKG) boýunça taslama kärhanalaryň we beýleki obýektleriň işleri akdyrylýan hapa suwlaryň we yzyna gaýtarylýan suwlaryň döremegine getirýän bolsa, şolar üçin düzülmelidir.
                </p>
                <br/><br/>

                <h2>RUGSAT EDILÝÄN AŇRYÇÄK DÖKMELERE KADA GÖRKEZIJILERI (READKG) BOÝUNÇA TASLAMA NÄDIP TAKYK DÜZÜLÝÄR?</h2>
                <p>Rugsat edilýän aňryçäk dökmelere kada görkezijileri (READKG) boýunça taslama “Suw obýektlerine akdyrylýan hapa suwlar bilen birlikde gelýän dökmeleriň rugsat edilýän aňryçäk kada görkezijilerini kesgitlemek boýunça usuly görkezmeleriň” talaplaryna laýyklykda işlenip düzülýär.</p>
                <p><b>Rugsat edilýän aňryçäk dökmelere kada görkezijileri (READKG) boýunça taslamany birnäçe tapgyrda sowatly işläp düzmek şular arkaly amala aşyrylýar:</b></p>
                <p>— Akdyrylýan galyndylaryň şol kärhanada ýerleşýän ähli çeşmelerini, arassalaýjy desgalaryň we ýagyn suwlaryny akdyrmak üçin kanalizasiýalaryň ählisini tükellemek arkaly;</p>
                <p>— Dökmeleri akdyrmagyň (sowmagyň) başa baryp biljek ähli usullaryny ýüze çykarmak arkaly.</p>
                <p>— Şu maglumatlara esaslanmak arkaly, Dökmeleriň rugsat edilýän normatiwleriniň (DREN) taslamasy işlenip düzülýär, oňa şular goşulýar:</p>
                <ul>
                    <li>kärhana (işiň haýsy ugur boýunça alnyp barylýandygy, daşky gurşawa ýetirilýän täsir) baradaky maglumat;</li>
                    <li>taslama hem-de zyýanly maddalaryň howdana akdyrylýan hakykatdaky mukdaryna degişli hasaplamalar;</li>
                    <li>dökmeleriň rugsat edilýän normatiwlerine laýyk gelmegini üpjün edýän teklipler.</li>
                </ul>

                <p>— Suwuň goralmagy baradaky maksatnamany işläp düzmek.</p>
                <p>— Işler berjaý edilen mahalynda, akymlar seljerilmelidir. Normatiwleriň ýerine ýetirilmegini üpjün etmek üçin, ilki bilen, suwda bar bolan himiki maddalary we hapalanyşyň derejesini kesgitlemek gerek;</p>
                <p>— Ekologik barlagyň meýilnamasyny-grafigini düzmek. Taslamany düzmek tamamlanandan soňra, dökmeleriň rugsat edilýän normatiwleri barada döwlet instansiýalarynda ylalaşylýar.</p>
                <br/><br/>
                <p>
                    <b>YLALAŞMAK WE HEREKET ETMEGIŇ MÖHLETLERI</b> obýekt üçin, rugsat edilýän aňryçäk dökmelere kada görkezijiler Türkmenistanyň Oba hojalygy we daşky gurşawy goramak ministrliginiň Daşky gurşawy goramak gullugynda ylalaşylýar. Ylalaşmak rugsat berýän degişli namany almak üçin esas bolup durýar.
                </p>
                <br/>
                <h2 className="service_content_footer">RUGSAT EDILÝÄN AŇRYÇÄK DÖKMELERE KADA GÖRKEZIJILERI (READKG) BOÝUNÇA TASLAMANYŇ HEREKET EDÝÄN MÖHLETI – 5 ÝYL.</h2>
                <br/>
                <h2>USSAT HÜNÄRMENLERIŇ ServicesY</h2>
                <p>
                    Biziň hünärmenlerimiz taslamanyň işlenip düzülmegini ýokary derejede bahym we ähli kadalaşdyryjy namalara laýyklykda amala aşyrýarlar. Taslamanyň dürs işlenip taýýarlanmagy ylalaşmagyň üstünlikli amala aşyrylmagynyň kepilidir. Munuň özi geljekde kärhanany kynçylykly meseleleriň ýüze çykmagyndan goraýar. Contact us we biz ekologiýa boýunça islendik işleri göwnejaý hilli we elýeterli baha boýunça ýerine ýetireris.
                </p>
                <br/><br/>
                <h2 className="service_content_footer">AŞAKDA GÖRKEZILEN GÖRNÜŞDÄKI TALAPNAMANY TABŞYRYŇ ÝA-DA BIZE JAŇ EDIŇ.</h2>
            </div>
        </div>

        <FeedbackSection margin_top="margin_top" />    

    </main>
  )
}

export default Service3Page